import styled from 'styled-components';
export const Separator = styled.div.withConfig({
  displayName: "Separator",
  componentId: "sc-rcixfk-0"
})(["width:1px;height:36px;padding:5px 0;margin-left:9px;background-color:", ";"], _ref => {
  let {
    theme
  } = _ref;
  return theme.colors.primaryL;
});